import {
  gsap
} from "gsap";
import {
  ScrollTrigger
} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
export const reset_password = () => {
  const
    helpers = {
      smoothScrollTo: () => import('./../helpers/smooth-scroll-to'),
      updateSmoothScroll: () => import('./../helpers/smooth-scroll-update'),
    },
    smoothScroller = document.querySelector('.smooth-scroll'),
    validateEmail = (email) => {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    };

  function refreshScroll() {
    ScrollTrigger.refresh()
    helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
  }

  function scrollToZero() {
    helpers.smoothScrollTo().then(module => {
      module.smoothScrollTo("#checkout")
    })
  }
  
  $(".btn--send-request").click(function() {
    var send = true;
    $(".error").removeClass("error");
    var parentForm = $(this).closest(".form-send-request");
    var form_name = $("input[name='action']", this).val();
    $(".mandatory", parentForm).each(function(index) {
      if ($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) {
        return;
      }
      if (!$(this).val()) {
        $(this).closest(".field").addClass("error");
        send = false;
      }
    });
    $("input[type='radio'].mandatory,input[type='checkbox'].mandatory", parentForm).each(function(index) {
      if ($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) return;
      if ($("input[name='" + $(this).attr("name") + "']:checked", parentForm).length < 1) {
        $(this).closest(".field").addClass("error");
        send = false;
      }
    });
    if ($("input[name='repeat-email-login']", parentForm).val() != $("input[name='email-login']", parentForm).val() || !validateEmail($("input[name='repeat-email-login']", parentForm).val())) {
      $("input[name='repeat-email-login']", parentForm).closest('.field').addClass("error");
      $("input[name='email-login']", parentForm).closest('.field').addClass("error");
      send = false;
    }

    // if($("input[name='change-password-checkbox']").is(":checked") && (($("input[name='change-password']").val() != $("input[name='repeat-change-password']").val()) || $("input[name='change-password']").val().length < 8)) {
    //   $("input[name='change-password']").closest(".field").addClass("error");
    //   $("input[name='repeat-change-password']").closest(".field").addClass("error");
    //   send = false;
    // }

    if (send) {
      $(".btn--send-request").addClass("opacity-40 pointer-events-none");
      var formData = {};
      $('.form-send-request input,.form-send-request select').each(function() {
        var fieldName = $(this).attr('name');
        var fieldValue = $(this).val();
        if($(this).attr("type") == "checkbox") {
          formData[fieldName] = $(this).is(":checked");
        } else {
          formData[fieldName] = fieldValue;
        }
      });
      console.log(formData);
      jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          action: 'functions',
          function: 'send_email_reset_pw',
          data: formData
        },
        success: function(response) {
           try {
            var jsonObject = JSON.parse(response);
            if(!jsonObject.result) {
               $(".btn--send-request").removeClass("opacity-40 pointer-events-none");
            } else {
                $(".btn--send-request").remove();
                setTimeout(function() {
                  refreshScroll();
                }, 50);
            }
            $(".message-send-reset").text(jsonObject.message);
          } catch (error) {
            $(".btn--send-request").removeClass("opacity-40 pointer-events-none");
            $(".message-send-reset").text("Error");
          }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          console.log("Status: " + textStatus,"Error: " + errorThrown);
        },
      });


    } else {
      helpers.smoothScrollTo().then(module => {
        module.smoothScrollTo(".error", null, -100)
      })
    }



  });



  $(".btn--send-reset").click(function() {
    var send = true;
    $(".error").removeClass("error");
    var parentForm = $(this).closest(".form-send-reset");
    var form_name = $("input[name='action']", this).val();
    $(".mandatory", parentForm).each(function(index) {
      if ($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) {
        return;
      }
      if (!$(this).val()) {
        $(this).closest(".field").addClass("error");
        send = false;
      }
    });
    $("input[type='radio'].mandatory,input[type='checkbox'].mandatory", parentForm).each(function(index) {
      if ($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) return;
      if ($("input[name='" + $(this).attr("name") + "']:checked", parentForm).length < 1) {
        $(this).closest(".field").addClass("error");
        send = false;
      }
    });

    if((($("input[name='change-password']").val() != $("input[name='repeat-change-password']").val()) || $("input[name='change-password']").val().length < 8)) {
      $("input[name='change-password']").closest(".field").addClass("error");
      $("input[name='repeat-change-password']").closest(".field").addClass("error");
      send = false;
    }

    if (send) {
      $(".btn--send-reset").addClass("opacity-40 pointer-events-none");
      var formData = {};
      $('.form-send-reset input,.form-send-reset select').each(function() {
        var fieldName = $(this).attr('name');
        var fieldValue = $(this).val();
        if($(this).attr("type") == "checkbox") {
          formData[fieldName] = $(this).is(":checked");
        } else {
          formData[fieldName] = fieldValue;
        }
      });
      console.log(formData);
      jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          action: 'functions',
          function: 'send_reset_pw',
          data: formData
        },
        success: function(response) {
          //console.log(response);

          try {
            var jsonObject = JSON.parse(response);
            if(!jsonObject.result) {
               $(".btn--send-reset").removeClass("opacity-40 pointer-events-none");
            } else {
                $(".btn--send-reset").remove();
                setTimeout(function() {
                  refreshScroll();
                }, 50);
            }
            $(".message-send-reset").text(jsonObject.message);
          } catch (error) {
            $(".btn--send-request").removeClass("opacity-40 pointer-events-none");
            $(".message-send-reset").text("Error");
          }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          console.log("Status: " + textStatus,"Error: " + errorThrown);
        },
      });


    } else {
      helpers.smoothScrollTo().then(module => {
        module.smoothScrollTo(".error", null, -100)
      })
    }



  });

  



}